import { createEmptyAction, createMapAction } from "chalet-shared";

export type DTFMButton = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | "*" | "#";

export const actionCreators = {
    toggleRosterDialpad: createEmptyAction("DIALPAD_TOGGLE"),
    dialpadSetText: createMapAction("DIALPAD_SET_TEXT", (x: string) => x),
    dialpadSMSPressed: createMapAction("DIALPAD_SMS_PRESSED", (x: string) => x),
};
